import axios from "../../../../api/axios";
import { UserProfileResponse } from "../types/profile.types";

export const getUserProfile = async (userId: string): Promise<UserProfileResponse> => {
  try {
    const response = await axios.get<UserProfileResponse>(`users/${userId}/v1`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch user profile: ${(err as Error).message}`);
  }
};
